import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'next/navigation'
import {
  FETCH_AVAILABILITY_CALENDAR,
  fetchAvailabilityCalendar,
} from './fetchAvailabilityCalendar'
import useAuthentication from '../useAuthentication'
import type { AvailabilityCalendarModel } from 'core/bookings/types'

function useQueryAvailabilityCalendar({
  year_month,
  nights,
  hotelId,
  rooms,
  showResale,
}: {
  year_month: string
  nights: number
  hotelId?: number
  rooms: {
    adults: number
    children: number
  }[]
  showResale?: boolean
}): UseQueryResult<AvailabilityCalendarModel | null | undefined> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [
      FETCH_AVAILABILITY_CALENDAR,
      { year_month, nights, hotelId, rooms, locale, showResale },
    ],
    queryFn: withTriplaApiRequest(fetchAvailabilityCalendar),
    enabled: !!hotelId && !!year_month && !!nights,
    // 1 min: dedupe the per-navigation refetches of overlapping months. The
    // picker's disabled dates are a hint; the results page re-validates real
    // availability at search time.
    staleTime: 60 * 1000,
  })
}

export default useQueryAvailabilityCalendar
